import { render, staticRenderFns } from "./ObligationTransfer.vue?vue&type=template&id=06d264ba&scoped=true&"
import script from "./ObligationTransfer.vue?vue&type=script&lang=js&"
export * from "./ObligationTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ObligationTransfer.vue?vue&type=style&index=0&id=06d264ba&scoped=true&lang=css&"
import style1 from "./ObligationTransfer.vue?vue&type=style&index=1&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d264ba",
  null
  
)

export default component.exports